import { render, staticRenderFns } from "./student-tag-revise.vue?vue&type=template&id=fd318de0&scoped=true"
import script from "./student-tag-revise.vue?vue&type=script&lang=js"
export * from "./student-tag-revise.vue?vue&type=script&lang=js"
import style0 from "./student-tag-revise.vue?vue&type=style&index=0&id=fd318de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd318de0",
  null
  
)

export default component.exports